export const head = <T>(list?: T[]): T => {
  const [h] = list || [];
  return h;
};

export const tail = <T>(list?: T[]): T[] => {
  const [_, ...t] = list || [];
  return t;
};
